var quoteForm = $("#quote-form");
var unitOwner = new FObject("input[name='unit_owner']");
var ownerLifestyle = new FObject("input[name='owner_lifestyle']");
var ownerReason = new FObject("input[name='owner_reason']");
// var userLocation = new FObject('#user_location');
var firstName = new FObject('#user_first');
var lastName = new FObject('#user_last');
var email = new FObject('#user_email');
var phone_user = new FObject('#user_phone');
var phone = new FObject("#user_phone_input");
var phoneNew = new FObject('#phone-new');
var emailCheck = $("#email_check");

var theme_color = null;
var theme_color_two =  "rgba(211,17,60,0.5)"; //"#d3113c";
apiResponse = null;
validationObject = {};

var campaign = {
    source: $('#campaign_source'),
    referrer: $('#campaign_referrer')
};

var locations = {
    location_city: $('.city'),
    location_state: $('.state'),
    location_zip: $('.zip')
};

var user = {
    first: $('#user_first'),
    last: $('#user_last'),
    email: $('#user_email'),
    phone: $('#user_phone'),
    emailError: null,
    emailReplacement: null,
    emailIsValid: null
};

getFieldObject = function(id) {
    switch(id) {
        case "user_location":
            return userLocation;
            break;
        case "user_first":
            return firstName;
            break;
        case "user_last":
            return lastName;
            break;
        case "user_email":
            return email;
            break;
        case "phone_user":
            return phone_user;
            break;
        case "user_phone_input":
            return phone;
            break;
        default:
            return null;
    }

};


function FObject(name) {
    this.placeholderText = "";
    this.timeout = 1000;

    this.initPlaceholder = function() {
        // split string into character seperated array
        var arr = this.placeholderText.split(''),
            input = this.field,
            // store full placeholder
            origString = string,
            // get current placeholder value
            curPlace = input.attr("placeholder"),
            // append next letter to current placeholder
            placeholder = curPlace + arr[phCount];

        setTimeout(function(){
            // print placeholder text
            input.attr("placeholder", placeholder);
            // increase loop count
            phCount++;
            // run loop until placeholder is fully printed
            if (phCount < arr.length) {
                printLetter(origString, input);
            }

        }, randDelay(50, 90));
    };

    this.$form = $("#quote-form");




    this.getNamespace = function() {
      var $withId = $(name).attr('id');

      if(typeof $withId == "undefined") {
          return this.field.attr('name');
      }
          return $withId;
    };

    // this.namespace = this.getNamespace();


    this.field = $(name);

    this.focusNext = function(fieldObj) {
        fieldObj.field.focus();
    };

    this.loaderOnFinal = function() {
        this.style('valid');
    };


    this.loaderOff = function() {
        $('.spinner').css('visibility','hidden');
    };

    this.valid = {
        "color": "#177EFB",
        "background": "#f1faff url('images/check.svg') right no-repeat",
        "background-size": "32px 32px",
        "border": "solid 1px rgba(72,131,179,0.5)"
    };

    this.default = {
        "color": "#333",
        "background": "#fff",
        "border": "none"
    };

    this.error = {
        "color": "#333",
        "background": "#efefef",
        "border": "solid 1px #a94442"
    };

    this.loaderOn = function() {
        $('.spinner').css('visibility','visible');
    };

    this.setData = function(name, value) {
        this.field.data(name, value);
        if(name =='valid') {
            validationObject[this.namespace] = value;
        }
        return this;
    };

    this.hide = function(e){
        this.field.hide();
        return this;
    };

    this.show = function(e){
        this.field.show();
        return this;
    };

    this.getData = function(name) {
        return this.field.data(name);
    };

    this.nameIsValidCheck = function() {
        return firstName.field.val().length >= 2 && lastName.field.val().length >= 2 ? 1 : 0;
    };


    this.style = function(style) {
        if (style == 'error') {
            validationObject[this.namespace] = 0;
            this.field.css(this.error);
            this.setData('valid',0);
        } else if (style == 'valid') {
            validationObject[this.namespace] = 1;
            this.field.css(this.valid);
            this.setData('valid',1);
            this.resolveErrorMessages();
        } else if(style == 'default') {
            this.field.parents('div.input-group').css(this.default);
            this.setData('valid',null);
        }
        return this;
    };

    this.resolveErrorMessages = function() {
        $(document).find(".error_" + this.field.attr('id')).remove();
        if($("#errors-list *").length == 0) {
            $(".fix-errors-message").hide();
        }
    };


    this.setVal = function(value) {
        this.field.val(value);
        return this;
    };

    this.getVal = function() {
        // get value for radio button
        if (this.field.is(':radio')) {
            return $('input[name="'+ this.getNamespace() +'"]:checked').val();
        } else if( this.field.is(':checkbox') ) {
            var checkedVals = [];
            $.each($("input[name='" + this.getNamespace() +"']:checked"), function(){
                checkedVals.push($(this).val());
            });

            return checkedVals;

        } else {
            return this.field.val();
        }
    };

    this.getNextButton = function() {
        return this.field.find('.tab-linker-next').first();
    };

    this.event = function(event) {
        this.field.on(event);
        return this;
    };

    this.setObjectValidation = function(isValid) {
        validationObject[this.getNamespace()] = isValid;
    };

    this.setValidationError = function(message) {
        var container = this.validationContainer();
        container.css('display','block');
        container.toggleClass('alert-danger','alert-success');
        container.slideDown();
        container.children('div').html(message);
        return this;
    };

    this.setValidationSuccess = function(message) {
        var container = this.validationContainer();
        container.css('display','block');
        container.toggleClass('alert-success','alert-danger');
        container.slideDown();
        container.children('div').html(message);
        return this;
    };


    this.validationContainer = function() {
        var className = '.' + this.getNamespace() + '_messages';
        return $(className);
    };

    this.removeValidationError = function() {
        var container = this.validationContainer();
        // container.css('visibility','hidden');
        container.fadeOut();
        return this;
    };

    this.setValid = function () {
        this.setData('valid', true);
        this.style('valid');
        return this;
    };

    this.isValid = function() {
        if(this.field.data('valid') == "undefined" || !this.field.data('valid') ) {
            return false;
        } else {
            return true;
        }

    };

    this.setInvalid = function() {
        this.setData('valid', false);
        this.style('error');
        return this;
    };

    this.setDefault = function() {
        this.field.val('');
        this.style('default');
        this.setData('valid', false);
        return this;
    };

    this.setDynamicMessage = function() {
        if(year.getData('valid')) {
            $('span.vehicle-title').fadeIn('slow');
        }
        if(origin.getData('valid')) {
            $('span.route-title').fadeIn('slow');
        }

        $("span." + this.namespace).fadeIn(2000).html(this.getVal());
    };

    this.getCheckedValues = function() {

        var result = $("." + this.getNamespace() +":checked").map(function () {
            var $this = $(this);
            return $this.val();
        }).get().join(", ");

        return result;
    };


}


$('input.input__field').on('keydown, keyup', function(e){
    var namespace = $(this).attr('id');
    var fieldObject = getFieldObject(namespace);
    fieldObject.removeValidationError();

    if((e.keyCode == 8 || e.keyCode == 46)) {
        fieldObject.style('default');
        fieldObject.getButtonNext().css('visibility','hidden');
    }

});


var options = {
    onComplete: function (cep) {
        phone.field.val(phone.field.cleanVal());

    }
};

phone.field.mask('(000) 000-0000',options);


firstName.style('default');
lastName.style('default');
email.style('default');
phone.style('default');

if (document.getElementsByTagName) {
    var inputElements = document.getElementsByTagName("input");
    for (i=0; inputElements[i]; i++) {
        if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off");
        }
    }
}





